import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    const len = this.element.value.length || 1
    this.element.style.width = `calc(${len}ch + 5px)`
  }
}
